import {ChangeDetectionStrategy, Component, ViewEncapsulation} from "@angular/core"

@Component({
    selector: "iinvest-root",
    templateUrl: "./AppComponent.html",
    styleUrls: ["./AppComponent.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
}
